









































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { CreatorService } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues, QuickTip } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import ModalView from "@/components/ModalView";
import QuickTipsItem from "@/components/QuickTipsItem";
import InputMediaFile from "@/components/ui/InputMediaFile";
import { CATEGORIES_OPTIONS, CREATOR_SERVICE_TAGS } from "@/features/CreatorService/const";

export default defineComponent({
  name: "CreatorServiceCreateEditModal",
  components: { InputMediaFile, QuickTipsItem, BaseButton, BaseForm, ModalView },
  props: {
    item: { type: Object as PropType<CreatorService>, default: undefined },
  },
  setup(props, { emit }) {
    const title = computed(() => (props.item ? $t("Edit service") : $t("Add service")));

    const values = ref<FormValues>({
      title: props.item?.title,
      description: props.item?.description,
      price: props.item?.price ? props.item.price.toString() : "",
      category: props.item?.category,
      preview: props.item?.preview,
      tags: props.item?.tags ?? ([] as string[]),
    });
    const formValid = ref(false);
    const loading = ref(false);
    const warnings: QuickTip[] = [
      {
        icon: "sci-information-outline",
        translateKey: "It is forbidden to sell tangible products on CiaoFan",
        type: "info",
      },
      {
        icon: "sci-information-outline",
        translateKey:
          "If you don't deliver the service as agreed, the credits will be deducted and refunded to the user (subject to verification)",
        type: "info",
      },
    ];

    const fields: FormFields = [
      {
        name: "category",
        label: $t("Category"),
        placeholder: $t("Select from list"),
        type: "select",
        rules: ["required"],
        required: true,
        options: CATEGORIES_OPTIONS,
      },
      {
        name: "title",
        label: $t("Title"),
        placeholder: $t("30 min private call"),
        rules: ["required"],
        required: true,
      },
      {
        name: "description",
        label: $t("Description"),
        placeholder: $t("Service details"),
        type: "textarea",
      },
      {
        name: "price",
        label: $t("Price"),
        rules: ["required"],
        type: "money",
        required: true,
      },
    ];

    const isValid = computed(() => formValid.value && values.value.preview && values.value.tags.length > 0);

    const onSelectTag = (id: string) => {
      if (values.value.tags.includes(id)) {
        values.value.tags = values.value.tags.filter((i: string) => i !== id);
      } else {
        if (values.value.tags.length >= 3) return;
        values.value.tags = [...values.value.tags, id];
      }
    };

    const onSubmit = () => {
      if (!isValid.value) return;
      loading.value = true;

      const { preview, price, ...data } = values.value;
      let previewFile: File | null = null;

      data.price = Number(price);
      if (preview instanceof File) previewFile = preview;
      if (props.item) data.id = props.item.id;

      emit("update", data, previewFile, () => {
        loading.value = false;
      });
    };

    return {
      title,
      fields,
      values,
      formValid,
      isValid,
      loading,
      warnings,
      CREATOR_SERVICE_TAGS,
      onSubmit,
      onSelectTag,
    };
  },
});
